import apiSportEvents from '@/api/sports-events'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  createSportEventStart: '[create sport event] Create sport event start',
  createSportEventSuccess: '[create sport event] Create sport event success',
  createSportEventFailure: '[create sport event] Create sport event failure'
}

export const actionTypes = {
  createSportEvent: '[create sport event] Create sport event'
}

const mutations = {
  [mutationTypes.createSportEventStart](state) {
    state.isSubmitting = true
    state.error = null
  },

  [mutationTypes.createSportEventSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.createSportEventFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.createSportEvent](context, {sportEvent}) {
    context.commit(mutationTypes.createSportEventStart)
    return new Promise(resolve => {
      apiSportEvents
        .addSportEvent(sportEvent)
        .then(response => {
          context.commit(mutationTypes.createSportEventSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.createSportEventFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
